import { EmailReportMailTypeRowOutDto } from '@app/swagger-types';
import { Tooltip } from '@mui/material';

import { EmailCard } from '../../shared/EmailCard';
import { StatusPill } from '../../shared/StatusPill';

// admin-emailbeheer blok B (opdracht §4, "Tabel per mailtype"). opens carries a footnote - the
// opdracht's own caveat that Apple Mail Privacy Protection prefetches images for ~62% of
// recipients, so the absolute number isn't a steering metric.
export const EmailReportMailTypeTable: React.FC<{ rows: EmailReportMailTypeRowOutDto[] }> = ({ rows }) => {
  return (
    <EmailCard title="Per mail type" subtitle="Last 30 days">
      <div className="overflow-x-auto">
        <table className="w-full text-left text-xs">
          <thead>
            <tr className="border-b border-gray-200 text-gray-400">
              <th className="py-2 pr-3">Mail key</th>
              <th className="py-2 pr-3 text-right">Sent</th>
              <th className="py-2 pr-3 text-right">Delivered</th>
              <th className="py-2 pr-3 text-right">
                <Tooltip title="Not a steering metric - Apple Mail Privacy Protection prefetches images for ~62% of recipients.">
                  <span>Opens*</span>
                </Tooltip>
              </th>
              <th className="py-2 pr-3 text-right">Clicked</th>
              <th className="py-2 pr-3 text-right">Unsubscribed</th>
              <th className="py-2 pr-3 text-right">Complaints</th>
              <th className="py-2 text-right">
                <Tooltip title="The number that actually counts - unlike opens, an upgrade can't be faked.">
                  <span>Upgrades &lt;72h</span>
                </Tooltip>
              </th>
            </tr>
          </thead>
          <tbody>
            {rows.map((row, i) => (
              <tr key={row.mailKey} className={i % 2 === 1 ? 'bg-gray-50' : undefined}>
                <td className="font-mono py-1.5 pr-3">{row.mailKey}</td>
                <td className="py-1.5 pr-3 text-right">{row.sent.toLocaleString()}</td>
                <td className="py-1.5 pr-3 text-right text-gray-700">{row.deliveredPercent.toFixed(1)}%</td>
                <td className="py-1.5 pr-3 text-right text-gray-400">{row.openedPercent.toFixed(1)}%</td>
                <td className="py-1.5 pr-3 text-right text-gray-700">{row.clickedPercent.toFixed(1)}%</td>
                <td className="py-1.5 pr-3 text-right">
                  {row.unsubscribedAboveThreshold ? (
                    <StatusPill variant="warn">{row.unsubscribedPercent.toFixed(1)}%</StatusPill>
                  ) : (
                    `${row.unsubscribedPercent.toFixed(1)}%`
                  )}
                </td>
                <td className="py-1.5 pr-3 text-right">
                  {row.complaintAboveThreshold ? (
                    <StatusPill variant="bad">{row.complaintPercent.toFixed(2)}%</StatusPill>
                  ) : (
                    `${row.complaintPercent.toFixed(2)}%`
                  )}
                </td>
                <td className="py-1.5 text-right font-bold text-gray-800">{row.upgradesWithin72h.toLocaleString()}</td>
              </tr>
            ))}
            {!rows.length && (
              <tr>
                <td colSpan={8} className="py-4 text-center text-gray-400">
                  No mail sent in this period.
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
      <p className="mt-3 border-l-2 border-accept-medium pl-3 text-[12.5px] text-gray-700">
        <b className="text-gray-800">Opens are not reliable.</b> Apple Mail Privacy Protection prefetches images, and
        Apple accounts for roughly 62% of all opens. The column is there for the pattern, not to steer by.
      </p>
    </EmailCard>
  );
};
